import { LOADING_START, LOADING_END } from "./actionType";

const INIT_STATE = {
  loading: false,
};

const Loading = (state = INIT_STATE, action) => {
  switch( action.type ) {
    case LOADING_START:
      return {
        ...state, 
        loading: true 
      };
    case LOADING_END:
      return {
        ...state,
        loading: false 
      };
    default:
      return state;
  }
};

export default Loading;